/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from '@app/app.config';
import { AppComponent } from '@app/app.component';
import { environment } from '@environment/environment';

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);

if (environment.production && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/firebase-messaging-sw.js');
  });
}
